import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useSelector as useAppSelector } from "react-redux";
import commonSlice from "./slices/commonSlice";
import authSlice from "./slices/authSlice";
import venueSlice from "./slices/venueSlice";
import supplierSlice from "./slices/supplierSlice";
import userSlice from "./slices/userSlice";
import enquirySlice from "./slices/enquirySlice";
import tableSlice from "./slices/tableSlice";
import eventSlice from "./slices/eventSlice";
import dashboardSlice from "./slices/dashboardSlice";
import paymentSlice from "./slices/paymentSlice";

const rootReducer = combineReducers({
  common: commonSlice,
  auth: authSlice,
  venue: venueSlice,
  supplier: supplierSlice,
  user: userSlice,
  enquiry: enquirySlice,
  table: tableSlice,
  dashboard:dashboardSlice,
  event:eventSlice,
  payment:paymentSlice
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these field paths in all actions
        ignoredActions: ['enquiry/setAttachmentFile'],
        ignoredPaths: ['enquiry.clientAttachmentFile'],
      },
    }),
});

export type AppState = ReturnType<typeof rootReducer>;
export const { dispatch } = store;
export type AppDispatch = typeof store.dispatch;
export const useSelector: TypedUseSelectorHook<AppState> = useAppSelector;

export default store;